import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "min-h-screen flex items-center justify-center bg-primary-100 px-4"
}
const _hoisted_2 = {
  role: "alert",
  class: "w-full max-w-sm rounded-2xl bg-white px-6 py-8 text-center shadow-sm"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "text-xl font-bold text-gray-800" }, "読み込めませんでした", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-sm text-gray-600" }, [
  /*#__PURE__*/_createTextVNode(" 通信状況を確認して、"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("もう一度お試しください。 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MButton = _resolveComponent("MButton")
  const _component_ChangePassword = _resolveComponent("ChangePassword")
  const _component_MLoadingOverlay = _resolveComponent("MLoadingOverlay")
  const _component_MLangToggleBox = _resolveComponent("MLangToggleBox")
  const _component_router_view = _resolveComponent("router-view")
  const _component_m_user_modal = _resolveComponent("m-user-modal")
  const _component_ms_add_message_template_modal = _resolveComponent("ms-add-message-template-modal")
  const _component_ms_edit_message_template_modal = _resolveComponent("ms-edit-message-template-modal")

  return (_ctx.passwordState.error)
    ? (_openBlock(), _createBlock("main", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_MButton, {
            class: "mt-6 w-full justify-center",
            "font-weight": "bold",
            disabled: _ctx.retrying,
            onClick: _ctx.retryPassword
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.retrying ? "読み込み中…" : "もう一度読み込む"), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode("button", {
            type: "button",
            class: "mt-3 rounded-md px-2 py-1 text-sm text-gray-600 hover:bg-primary-100",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logoutFromError && _ctx.logoutFromError(...args)))
          }, " ログアウト ")
        ])
      ]))
    : (_ctx.passwordScreen)
      ? (_openBlock(), _createBlock(_component_ChangePassword, { key: 1 }))
      : (!_ctx.passwordState.ready)
        ? (_openBlock(), _createBlock(_component_MLoadingOverlay, { key: 2 }))
        : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
            (_ctx.showLangToggleBox)
              ? (_openBlock(), _createBlock(_component_MLangToggleBox, {
                  key: 0,
                  class: "fixed right-4 top-10"
                }))
              : _createCommentVNode("", true),
            (!_ctx.isFetchingRole)
              ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.isOpenUserModal)
              ? (_openBlock(), _createBlock(_component_m_user_modal, {
                  key: 2,
                  onClose: _ctx.closeUserModal
                }, null, 8, ["onClose"]))
              : _createCommentVNode("", true),
            (_ctx.isOpenAddMessageTemplateModal)
              ? (_openBlock(), _createBlock(_component_ms_add_message_template_modal, {
                  key: 3,
                  "default-content": _ctx.defaultMessageContent,
                  onClose: _ctx.closeAddMessageTemplateModal
                }, null, 8, ["default-content", "onClose"]))
              : _createCommentVNode("", true),
            (_ctx.isOpenEditMessageTemplateModal && _ctx.selectedMessageTemplate)
              ? (_openBlock(), _createBlock(_component_ms_edit_message_template_modal, {
                  key: 4,
                  "message-template": _ctx.selectedMessageTemplate,
                  onClose: _ctx.closeEditMessageTemplateModal
                }, null, 8, ["message-template", "onClose"]))
              : _createCommentVNode("", true),
            (_ctx.loading || _ctx.isFetchingRole)
              ? (_openBlock(), _createBlock(_component_MLoadingOverlay, { key: 5 }))
              : _createCommentVNode("", true)
          ], 64))
}